import { type ReactNode } from 'react';

import { IconButton } from '@breezeventures/ui-kit/icon-button';
import cn from 'classnames';

import backIcon from './back-icon.svg';
import closeIcon from './close-icon.svg';
import logo from './logo.svg';

export type ScreenHeaderProps = {
  onBack?: () => void;
  onClose?: () => void;
  logoAlign?: 'left' | 'center';
  rightSlot?: ReactNode;
};

export const ScreenHeader = ({
  onBack,
  onClose,
  rightSlot,
  logoAlign = 'center',
}: ScreenHeaderProps) => {
  return (
    <div
      className={cn('grid min-h-16 items-center gap-4 bg-white', {
        'p-4': !!rightSlot,
        'grid-cols-[1fr_auto_1fr]': logoAlign === 'center',
        'grid-cols-[0px_auto_1fr]': logoAlign === 'left',
      })}
    >
      <div className="flex">
        {onBack && (
          <IconButton
            variant="ghost"
            size="l"
            type="button"
            onClick={onBack}
            aria-label="Go back"
          >
            <img src={backIcon} alt="" className="size-8.5" />
          </IconButton>
        )}
      </div>

      <img src={logo} alt="Skyro" className="h-8.5" />

      <div className="flex justify-end">
        {onClose && (
          <IconButton
            variant="ghost"
            size="l"
            type="button"
            onClick={onClose}
            aria-label="Close"
          >
            <img src={closeIcon} alt="" className="size-8.5" />
          </IconButton>
        )}
        {rightSlot}
      </div>
    </div>
  );
};
